<template>
  <div class="recentAchievements" ref="recentAchievements">
    <div class="teamInfors">
      <span
        class="teamInfors_cell"
        v-for="team in datas.objectInfo"
        :key="team.teamId"
      >
        <span class="teamInfors_teamName" v-text="team.teamName"></span>
        <span class="teamInfors_teamLogo">
          <img :src="team.teamLogo" />
        </span>
      </span>
      <!-- <span class="teamInfors_cell">
        <span class="teamInfors_teamName">away</span>
        <span class="teamInfors_teamLogo">
          <img src="" />
        </span>
      </span> -->
    </div>
    <div class="echart_box">
      <div
        class="echart_dom"
        ref="echartDom_home"
        :style="{ height: `${pHeight}px` }"
      ></div>
      <div
        class="echart_dom"
        ref="echartDom_away"
        :style="{ height: `${pHeight}px` }"
      ></div>
    </div>
    <div class="tip_area">
      <span class="tip_cell">
        <i class="tipCell_icon"></i>
        <span class="tipCell_text">胜</span>
      </span>
      <span class="tip_cell">
        <i class="tipCell_icon"></i>
        <span class="tipCell_text">平</span>
      </span>
      <span class="tip_cell">
        <i class="tipCell_icon"></i>
        <span class="tipCell_text">负</span>
      </span>
    </div>
  </div>
</template>

<script>
// 近期战绩 主题
import canvasToImage_base64_data_mixin from '@mixins/canvasToImage_base64_data'
export default {
  name: 'recentAchievements',
  mixins: [canvasToImage_base64_data_mixin],
  props: {
    datas: {
      // 必传参数，球员的所有信息放到一个对象里
      type: Object,
      default: () => ({
        title: '',
        objectInfo: [],
        data: {
          dataList: [],
        },
        statisticsModels: [],
      }),
    },
    isAutoExportPng: {
      //是否导出图片页面使用
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      echartsArr: [],
      pHeight: 0,
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initDomWH()
      const teamInfor = this.datas.objectInfo
      setTimeout(() => {
        this.datas.data.dataList.forEach((data, i) => {
          if (i == 0) {
            this.initChart(
              this.$refs.echartDom_home,
              teamInfor[i],
              data,
              this.isAutoExportPng
            )
          } else {
            this.initChart(
              this.$refs.echartDom_away,
              teamInfor[i],
              data,
              this.isAutoExportPng
            )
          }
        })
      }, 10)
    })
  },
  beforeDestroy() {
    //性能优化，防止溢出
    if (this.myEChart) {
      this.myEChart.dispose() //销毁echarts实例，防止内侧泄露
    }
    this.echartsArr = []
  },
  methods: {
    initDomWH() {
      const echartsBoxDom = this.$refs.recentAchievements
      console.debug('recentAchievements:', echartsBoxDom.clientWidth)
      //横向一个
      this.pWidth = echartsBoxDom.clientWidth

      this.pHeight = Math.floor((this.pWidth / 2) * 0.75)
      console.debug('this.pWidth:', this.pWidth, this.pHeight)
    },
    initChart(echartRef, teamObject, data, isAutoExportPng) {
      const name = teamObject ? teamObject.teamName : '未知'
      let result = this.echartsArr.some((val) => {
        if (val.name === name) {
          return true
        }
      })

      console.debug('result', result)

      if (!result) {
        let Echart = this.$echarts.init(echartRef)
        this.echartsArr.push({
          name: name,
          refs: echartRef,
          echarts: Echart,
        })
        setTimeout(() => {
          Echart.resize()
        }, 0)
      }
      //   const originData = this.datas.data.dataList
      const pieBgColor = [
        'rgba(224, 20, 20, 1)',
        'rgba(113, 199, 191, 1)',
        'rgba(226, 137, 26, 1)',
      ]
      const keyArr = this.datas.statisticsModels
      const renderData = keyArr.map((ketItem, index) => {
        return {
          value: data[ketItem.columnName] ? data[ketItem.columnName] : 0,
          name: ketItem.name,
          itemStyle: {
            color: pieBgColor[index],
          },
        }
      })
      let options = {
        tooltip: {
          trigger: 'item',
        },
        // legend: {
        //   show: false,
        //   top: '5%',
        //   left: 'center',
        // },
        series: [
          {
            name,
            type: 'pie',
            // radius: ['40%', '70%'],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 10,
              borderColor: '#fff',
              borderWidth: 2,
            },
            label: {
              show: false,
              position: 'center',
            },
            // emphasis: {
            //   label: {
            //     show: true,
            //     fontSize: '10',
            //     fontWeight: 'bold',
            //   },
            // },
            labelLine: {
              show: false,
            },
            data: renderData,
          },
        ],
      }
      this.echartsArr.forEach((val, index) => {
        if (val.name === name) {
          console.debug('val.name:', val.name, 'name', name)
          val.echarts.setOption(options)
        }
      })
      //   console.debug('emitEventName:', isAutoExportPng)
      //   if (isAutoExportPng) {
      //     setTimeout(() => {
      //       this.upLoad(echartRef, true, 'uploadData')
      //     }, 500)
      //   }
    },
  },
}
</script>

<style lang="scss" scoped>
.recentAchievements {
  position: relative;
  width: 100%;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  .teamInfors {
    width: 100%;
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    align-items: center;
    .teamInfors_cell {
      width: 50%;
      display: flex;
      display: -webkit-flex;
      justify-content: center;
      align-items: center;
      .teamInfors_teamName {
        width: auto;
        max-width: calc(100% - 2.778vw);
        font-size: 1.25vw;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        color: rgba(0, 0, 0, 0.65);
      }
      .teamInfors_teamLogo {
        width: 2.778vw;
        height: 2.778vw;
        overflow: hidden;
        img {
          display: block;
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
      &:first-child {
        .teamInfors_teamName {
          padding-right: 0.694vw;
        }
      }
      &:nth-child(2) {
        flex-direction: row-reverse;
        .teamInfors_teamName {
          padding-left: 0.694vw;
        }
      }
    }
  }
  .echart_box {
    width: 100%;
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    align-items: center;
    .echart_dom {
      width: 50%;
    }
  }
  .tip_area {
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 2;
    width: 100%;
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    align-items: center;
    .tip_cell {
      width: auto;
      display: flex;
      display: -webkit-flex;
      justify-content: center;
      align-items: center;
      .tipCell_icon {
        width: 0.694vw;
        height: 0.556vw;
        border-radius: 0.278vw;
      }
      .tipCell_text {
        padding: 0 2.083vw 0 0.556vw;
        font-size: 0.972vw;
        color: rgba(0, 0, 0, 0.85);
      }
      &:first-child {
        .tipCell_icon {
          background-color: rgba(224, 20, 20, 1);
        }
      }
      &:nth-child(2) {
        .tipCell_icon {
          background-color: rgba(113, 199, 191, 1);
        }
      }
      &:nth-child(3) {
        .tipCell_icon {
          background-color: rgba(226, 137, 26, 1);
        }
      }
    }
  }
}
</style>
